module.exports = {
	"v": "4.8.0",
	"meta": {
		"g": "LottieFiles AE 3.4.5",
		"a": "",
		"k": "",
		"d": "",
		"tc": ""
	},
	"fr": 30,
	"ip": 0,
	"op": 121,
	"w": 300,
	"h": 440,
	"nm": "Iceberg_Loop_04_Lottie",
	"ddd": 0,
	"assets": [],
	"layers": [
		{
			"ddd": 0,
			"ind": 1,
			"ty": 4,
			"nm": "Wave Matte",
			"td": 1,
			"sr": 1,
			"ks": {
				"o": {
					"a": 0,
					"k": 100,
					"ix": 11
				},
				"r": {
					"a": 0,
					"k": 0,
					"ix": 10
				},
				"p": {
					"a": 0,
					"k": [
						150,
						220,
						0
					],
					"ix": 2
				},
				"a": {
					"a": 0,
					"k": [
						0,
						0,
						0
					],
					"ix": 1
				},
				"s": {
					"a": 0,
					"k": [
						100,
						100,
						100
					],
					"ix": 6
				}
			},
			"ao": 0,
			"shapes": [
				{
					"ind": 0,
					"ty": "sh",
					"ix": 1,
					"ks": {
						"a": 1,
						"k": [
							{
								"i": {
									"x": 0.833,
									"y": 0.833
								},
								"o": {
									"x": 0.167,
									"y": 0.167
								},
								"t": 0,
								"s": [
									{
										"i": [
											[
												0,
												0
											],
											[
												-50.636,
												0
											],
											[
												-50.636,
												0
											],
											[
												-50.636,
												0
											],
											[
												-50.635,
												0
											],
											[
												-50.636,
												0
											],
											[
												-50.636,
												0
											],
											[
												-50.636,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										"o": [
											[
												50.636,
												0
											],
											[
												50.636,
												0
											],
											[
												50.636,
												0
											],
											[
												50.635,
												0
											],
											[
												50.636,
												0
											],
											[
												50.636,
												0
											],
											[
												50.636,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										"v": [
											[
												-403.908,
												-83
											],
											[
												-302.637,
												-65.259
											],
											[
												-201.366,
												-83
											],
											[
												-100.093,
												-65.259
											],
											[
												1.177,
												-83
											],
											[
												102.45,
												-65.259
											],
											[
												203.723,
												-83
											],
											[
												304.996,
												-65.259
											],
											[
												304.996,
												235
											],
											[
												-403.908,
												235
											]
										],
										"c": true
									}
								]
							},
							{
								"t": 120,
								"s": [
									{
										"i": [
											[
												0,
												0
											],
											[
												-50.636,
												0
											],
											[
												-50.636,
												0
											],
											[
												-50.636,
												0
											],
											[
												-50.635,
												0
											],
											[
												-50.636,
												0
											],
											[
												-50.636,
												0
											],
											[
												-50.636,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										"o": [
											[
												50.636,
												0
											],
											[
												50.636,
												0
											],
											[
												50.636,
												0
											],
											[
												50.635,
												0
											],
											[
												50.636,
												0
											],
											[
												50.636,
												0
											],
											[
												50.636,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										"v": [
											[
												-202.908,
												-83
											],
											[
												-101.637,
												-65.259
											],
											[
												-0.366,
												-83
											],
											[
												100.907,
												-65.259
											],
											[
												202.177,
												-83
											],
											[
												303.45,
												-65.259
											],
											[
												404.723,
												-83
											],
											[
												505.996,
												-65.259
											],
											[
												505.996,
												235
											],
											[
												-202.908,
												235
											]
										],
										"c": true
									}
								]
							}
						],
						"ix": 2
					},
					"nm": "Path 1",
					"mn": "ADBE Vector Shape - Group",
					"hd": false
				},
				{
					"ty": "fl",
					"c": {
						"a": 0,
						"k": [
							1,
							0,
							0,
							1
						],
						"ix": 4
					},
					"o": {
						"a": 0,
						"k": 100,
						"ix": 5
					},
					"r": 1,
					"bm": 0,
					"nm": "Fill 1",
					"mn": "ADBE Vector Graphic - Fill",
					"hd": false
				}
			],
			"ip": 0,
			"op": 2700,
			"st": 0,
			"bm": 0
		},
		{
			"ddd": 0,
			"ind": 2,
			"ty": 4,
			"nm": "3A Iceberg Bottom/LiveMarket_Full_Page_forAe_01 Outlines",
			"parent": 3,
			"tt": 2,
			"sr": 1,
			"ks": {
				"o": {
					"a": 0,
					"k": 100,
					"ix": 11
				},
				"r": {
					"a": 0,
					"k": 0,
					"ix": 10
				},
				"p": {
					"a": 0,
					"k": [
						382,
						2800.5,
						0
					],
					"ix": 2
				},
				"a": {
					"a": 0,
					"k": [
						382,
						2800.5,
						0
					],
					"ix": 1
				},
				"s": {
					"a": 0,
					"k": [
						100,
						100,
						100
					],
					"ix": 6
				}
			},
			"ao": 0,
			"shapes": [
				{
					"ty": "gr",
					"it": [
						{
							"ind": 0,
							"ty": "sh",
							"ix": 1,
							"ks": {
								"a": 0,
								"k": {
									"i": [
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										]
									],
									"o": [
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										]
									],
									"v": [
										[
											-23.607,
											-44.583
										],
										[
											-26.316,
											13.817
										],
										[
											26.316,
											44.583
										]
									],
									"c": true
								},
								"ix": 2
							},
							"nm": "Path 1",
							"mn": "ADBE Vector Shape - Group",
							"hd": false
						},
						{
							"ty": "fl",
							"c": {
								"a": 0,
								"k": [
									0.866666726505,
									0.894117706897,
									0.933333393172,
									1
								],
								"ix": 4
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 5
							},
							"r": 1,
							"bm": 0,
							"nm": "Fill 1",
							"mn": "ADBE Vector Graphic - Fill",
							"hd": false
						},
						{
							"ty": "tr",
							"p": {
								"a": 0,
								"k": [
									420.618,
									2876.883
								],
								"ix": 2
							},
							"a": {
								"a": 0,
								"k": [
									0,
									0
								],
								"ix": 1
							},
							"s": {
								"a": 0,
								"k": [
									100,
									100
								],
								"ix": 3
							},
							"r": {
								"a": 0,
								"k": 0,
								"ix": 6
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 7
							},
							"sk": {
								"a": 0,
								"k": 0,
								"ix": 4
							},
							"sa": {
								"a": 0,
								"k": 0,
								"ix": 5
							},
							"nm": "Transform"
						}
					],
					"nm": "Group 1",
					"np": 2,
					"cix": 2,
					"bm": 0,
					"ix": 1,
					"mn": "ADBE Vector Group",
					"hd": false
				},
				{
					"ty": "gr",
					"it": [
						{
							"ind": 0,
							"ty": "sh",
							"ix": 1,
							"ks": {
								"a": 0,
								"k": {
									"i": [
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										]
									],
									"o": [
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										]
									],
									"v": [
										[
											-34.637,
											-37.539
										],
										[
											29.677,
											-22.059
										],
										[
											34.636,
											37.539
										]
									],
									"c": true
								},
								"ix": 2
							},
							"nm": "Path 1",
							"mn": "ADBE Vector Shape - Group",
							"hd": false
						},
						{
							"ty": "fl",
							"c": {
								"a": 0,
								"k": [
									0.376470618154,
									0.525490196078,
									0.729411764706,
									1
								],
								"ix": 4
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 5
							},
							"r": 1,
							"bm": 0,
							"nm": "Fill 1",
							"mn": "ADBE Vector Graphic - Fill",
							"hd": false
						},
						{
							"ty": "tr",
							"p": {
								"a": 0,
								"k": [
									362.375,
									2972.164
								],
								"ix": 2
							},
							"a": {
								"a": 0,
								"k": [
									0,
									0
								],
								"ix": 1
							},
							"s": {
								"a": 0,
								"k": [
									100,
									100
								],
								"ix": 3
							},
							"r": {
								"a": 0,
								"k": 0,
								"ix": 6
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 7
							},
							"sk": {
								"a": 0,
								"k": 0,
								"ix": 4
							},
							"sa": {
								"a": 0,
								"k": 0,
								"ix": 5
							},
							"nm": "Transform"
						}
					],
					"nm": "Group 2",
					"np": 2,
					"cix": 2,
					"bm": 0,
					"ix": 2,
					"mn": "ADBE Vector Group",
					"hd": false
				},
				{
					"ty": "gr",
					"it": [
						{
							"ind": 0,
							"ty": "sh",
							"ix": 1,
							"ks": {
								"a": 0,
								"k": {
									"i": [
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										]
									],
									"o": [
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										]
									],
									"v": [
										[
											-22.482,
											44.118
										],
										[
											-27.44,
											-15.48
										],
										[
											-7.781,
											-44.118
										],
										[
											27.44,
											-44.118
										]
									],
									"c": true
								},
								"ix": 2
							},
							"nm": "Path 1",
							"mn": "ADBE Vector Shape - Group",
							"hd": false
						},
						{
							"ty": "fl",
							"c": {
								"a": 0,
								"k": [
									0.6,
									0.690196078431,
									0.823529471603,
									1
								],
								"ix": 4
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 5
							},
							"r": 1,
							"bm": 0,
							"nm": "Fill 1",
							"mn": "ADBE Vector Graphic - Fill",
							"hd": false
						},
						{
							"ty": "tr",
							"p": {
								"a": 0,
								"k": [
									419.494,
									2965.584
								],
								"ix": 2
							},
							"a": {
								"a": 0,
								"k": [
									0,
									0
								],
								"ix": 1
							},
							"s": {
								"a": 0,
								"k": [
									100,
									100
								],
								"ix": 3
							},
							"r": {
								"a": 0,
								"k": 0,
								"ix": 6
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 7
							},
							"sk": {
								"a": 0,
								"k": 0,
								"ix": 4
							},
							"sa": {
								"a": 0,
								"k": 0,
								"ix": 5
							},
							"nm": "Transform"
						}
					],
					"nm": "Group 3",
					"np": 2,
					"cix": 2,
					"bm": 0,
					"ix": 3,
					"mn": "ADBE Vector Group",
					"hd": false
				},
				{
					"ty": "gr",
					"it": [
						{
							"ind": 0,
							"ty": "sh",
							"ix": 1,
							"ks": {
								"a": 0,
								"k": {
									"i": [
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										]
									],
									"o": [
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										]
									],
									"v": [
										[
											5.999,
											48.761
										],
										[
											-43.924,
											-40.404
										],
										[
											43.924,
											-48.761
										],
										[
											43.924,
											17.996
										]
									],
									"c": true
								},
								"ix": 2
							},
							"nm": "Path 1",
							"mn": "ADBE Vector Shape - Group",
							"hd": false
						},
						{
							"ty": "fl",
							"c": {
								"a": 0,
								"k": [
									0.580392156863,
									0.674509803922,
									0.815686334348,
									1
								],
								"ix": 4
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 5
							},
							"r": 1,
							"bm": 0,
							"nm": "Fill 1",
							"mn": "ADBE Vector Graphic - Fill",
							"hd": false
						},
						{
							"ty": "tr",
							"p": {
								"a": 0,
								"k": [
									440.936,
									2872.705
								],
								"ix": 2
							},
							"a": {
								"a": 0,
								"k": [
									0,
									0
								],
								"ix": 1
							},
							"s": {
								"a": 0,
								"k": [
									100,
									100
								],
								"ix": 3
							},
							"r": {
								"a": 0,
								"k": 0,
								"ix": 6
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 7
							},
							"sk": {
								"a": 0,
								"k": 0,
								"ix": 4
							},
							"sa": {
								"a": 0,
								"k": 0,
								"ix": 5
							},
							"nm": "Transform"
						}
					],
					"nm": "Group 4",
					"np": 2,
					"cix": 2,
					"bm": 0,
					"ix": 4,
					"mn": "ADBE Vector Group",
					"hd": false
				},
				{
					"ty": "gr",
					"it": [
						{
							"ind": 0,
							"ty": "sh",
							"ix": 1,
							"ks": {
								"a": 0,
								"k": {
									"i": [
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										]
									],
									"o": [
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										]
									],
									"v": [
										[
											8.321,
											-5.63
										],
										[
											-69.079,
											33.591
										],
										[
											18.77,
											25.233
										],
										[
											69.079,
											-33.591
										]
									],
									"c": true
								},
								"ix": 2
							},
							"nm": "Path 1",
							"mn": "ADBE Vector Shape - Group",
							"hd": false
						},
						{
							"ty": "fl",
							"c": {
								"a": 0,
								"k": [
									0.360784313725,
									0.482352971096,
									0.678431372549,
									1
								],
								"ix": 4
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 5
							},
							"r": 1,
							"bm": 0,
							"nm": "Fill 1",
							"mn": "ADBE Vector Graphic - Fill",
							"hd": false
						},
						{
							"ty": "tr",
							"p": {
								"a": 0,
								"k": [
									466.091,
									2798.709
								],
								"ix": 2
							},
							"a": {
								"a": 0,
								"k": [
									0,
									0
								],
								"ix": 1
							},
							"s": {
								"a": 0,
								"k": [
									100,
									100
								],
								"ix": 3
							},
							"r": {
								"a": 0,
								"k": 0,
								"ix": 6
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 7
							},
							"sk": {
								"a": 0,
								"k": 0,
								"ix": 4
							},
							"sa": {
								"a": 0,
								"k": 0,
								"ix": 5
							},
							"nm": "Transform"
						}
					],
					"nm": "Group 5",
					"np": 2,
					"cix": 2,
					"bm": 0,
					"ix": 5,
					"mn": "ADBE Vector Group",
					"hd": false
				},
				{
					"ty": "gr",
					"it": [
						{
							"ind": 0,
							"ty": "sh",
							"ix": 1,
							"ks": {
								"a": 0,
								"k": {
									"i": [
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										]
									],
									"o": [
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										]
									],
									"v": [
										[
											5.612,
											-26.364
										],
										[
											-25.348,
											-61.968
										],
										[
											-30.379,
											-26.364
										],
										[
											-30.379,
											61.968
										],
										[
											30.38,
											34.008
										]
									],
									"c": true
								},
								"ix": 2
							},
							"nm": "Path 1",
							"mn": "ADBE Vector Shape - Group",
							"hd": false
						},
						{
							"ty": "fl",
							"c": {
								"a": 0,
								"k": [
									0.866666726505,
									0.894117706897,
									0.933333393172,
									1
								],
								"ix": 4
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 5
							},
							"r": 1,
							"bm": 0,
							"nm": "Fill 1",
							"mn": "ADBE Vector Graphic - Fill",
							"hd": false
						},
						{
							"ty": "tr",
							"p": {
								"a": 0,
								"k": [
									504.79,
									2731.112
								],
								"ix": 2
							},
							"a": {
								"a": 0,
								"k": [
									0,
									0
								],
								"ix": 1
							},
							"s": {
								"a": 0,
								"k": [
									100,
									100
								],
								"ix": 3
							},
							"r": {
								"a": 0,
								"k": 0,
								"ix": 6
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 7
							},
							"sk": {
								"a": 0,
								"k": 0,
								"ix": 4
							},
							"sa": {
								"a": 0,
								"k": 0,
								"ix": 5
							},
							"nm": "Transform"
						}
					],
					"nm": "Group 6",
					"np": 2,
					"cix": 2,
					"bm": 0,
					"ix": 6,
					"mn": "ADBE Vector Group",
					"hd": false
				},
				{
					"ty": "gr",
					"it": [
						{
							"ind": 0,
							"ty": "sh",
							"ix": 1,
							"ks": {
								"a": 0,
								"k": {
									"i": [
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										]
									],
									"o": [
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										]
									],
									"v": [
										[
											0.072,
											-26.378
										],
										[
											-28.516,
											26.379
										],
										[
											28.516,
											7.872
										]
									],
									"c": true
								},
								"ix": 2
							},
							"nm": "Path 1",
							"mn": "ADBE Vector Shape - Group",
							"hd": false
						},
						{
							"ty": "fl",
							"c": {
								"a": 0,
								"k": [
									0.866666726505,
									0.894117706897,
									0.933333393172,
									1
								],
								"ix": 4
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 5
							},
							"r": 1,
							"bm": 0,
							"nm": "Fill 1",
							"mn": "ADBE Vector Graphic - Fill",
							"hd": false
						},
						{
							"ty": "tr",
							"p": {
								"a": 0,
								"k": [
									384.943,
									2658.37
								],
								"ix": 2
							},
							"a": {
								"a": 0,
								"k": [
									0,
									0
								],
								"ix": 1
							},
							"s": {
								"a": 0,
								"k": [
									100,
									100
								],
								"ix": 3
							},
							"r": {
								"a": 0,
								"k": 0,
								"ix": 6
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 7
							},
							"sk": {
								"a": 0,
								"k": 0,
								"ix": 4
							},
							"sa": {
								"a": 0,
								"k": 0,
								"ix": 5
							},
							"nm": "Transform"
						}
					],
					"nm": "Group 7",
					"np": 2,
					"cix": 2,
					"bm": 0,
					"ix": 7,
					"mn": "ADBE Vector Group",
					"hd": false
				},
				{
					"ty": "gr",
					"it": [
						{
							"ind": 0,
							"ty": "sh",
							"ix": 1,
							"ks": {
								"a": 0,
								"k": {
									"i": [
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										]
									],
									"o": [
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										]
									],
									"v": [
										[
											-7.353,
											-12.287
										],
										[
											3.702,
											12.287
										],
										[
											7.353,
											5.902
										]
									],
									"c": true
								},
								"ix": 2
							},
							"nm": "Path 1",
							"mn": "ADBE Vector Shape - Group",
							"hd": false
						},
						{
							"ty": "fl",
							"c": {
								"a": 0,
								"k": [
									0.376470618154,
									0.525490196078,
									0.729411764706,
									1
								],
								"ix": 4
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 5
							},
							"r": 1,
							"bm": 0,
							"nm": "Fill 1",
							"mn": "ADBE Vector Graphic - Fill",
							"hd": false
						},
						{
							"ty": "tr",
							"p": {
								"a": 0,
								"k": [
									308.776,
									2680.657
								],
								"ix": 2
							},
							"a": {
								"a": 0,
								"k": [
									0,
									0
								],
								"ix": 1
							},
							"s": {
								"a": 0,
								"k": [
									100,
									100
								],
								"ix": 3
							},
							"r": {
								"a": 0,
								"k": 0,
								"ix": 6
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 7
							},
							"sk": {
								"a": 0,
								"k": 0,
								"ix": 4
							},
							"sa": {
								"a": 0,
								"k": 0,
								"ix": 5
							},
							"nm": "Transform"
						}
					],
					"nm": "Group 8",
					"np": 2,
					"cix": 2,
					"bm": 0,
					"ix": 8,
					"mn": "ADBE Vector Group",
					"hd": false
				},
				{
					"ty": "gr",
					"it": [
						{
							"ind": 0,
							"ty": "sh",
							"ix": 1,
							"ks": {
								"a": 0,
								"k": {
									"i": [
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										]
									],
									"o": [
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										]
									],
									"v": [
										[
											26.122,
											7.838
										],
										[
											-26.123,
											18.481
										],
										[
											-5.805,
											-8.222
										],
										[
											3.676,
											-18.481
										]
									],
									"c": true
								},
								"ix": 2
							},
							"nm": "Path 1",
							"mn": "ADBE Vector Shape - Group",
							"hd": false
						},
						{
							"ty": "fl",
							"c": {
								"a": 0,
								"k": [
									0.756862804936,
									0.803921628466,
									0.87450986376,
									1
								],
								"ix": 4
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 5
							},
							"r": 1,
							"bm": 0,
							"nm": "Fill 1",
							"mn": "ADBE Vector Graphic - Fill",
							"hd": false
						},
						{
							"ty": "tr",
							"p": {
								"a": 0,
								"k": [
									419.264,
									2674.464
								],
								"ix": 2
							},
							"a": {
								"a": 0,
								"k": [
									0,
									0
								],
								"ix": 1
							},
							"s": {
								"a": 0,
								"k": [
									100,
									100
								],
								"ix": 3
							},
							"r": {
								"a": 0,
								"k": 0,
								"ix": 6
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 7
							},
							"sk": {
								"a": 0,
								"k": 0,
								"ix": 4
							},
							"sa": {
								"a": 0,
								"k": 0,
								"ix": 5
							},
							"nm": "Transform"
						}
					],
					"nm": "Group 9",
					"np": 2,
					"cix": 2,
					"bm": 0,
					"ix": 9,
					"mn": "ADBE Vector Group",
					"hd": false
				},
				{
					"ty": "gr",
					"it": [
						{
							"ind": 0,
							"ty": "sh",
							"ix": 1,
							"ks": {
								"a": 0,
								"k": {
									"i": [
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										]
									],
									"o": [
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										]
									],
									"v": [
										[
											18.963,
											12.284
										],
										[
											9.482,
											22.542
										],
										[
											-18.963,
											-11.707
										],
										[
											0.774,
											-22.542
										]
									],
									"c": true
								},
								"ix": 2
							},
							"nm": "Path 1",
							"mn": "ADBE Vector Shape - Group",
							"hd": false
						},
						{
							"ty": "fl",
							"c": {
								"a": 0,
								"k": [
									0.623529411765,
									0.698039215686,
									0.800000059838,
									1
								],
								"ix": 4
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 5
							},
							"r": 1,
							"bm": 0,
							"nm": "Fill 1",
							"mn": "ADBE Vector Graphic - Fill",
							"hd": false
						},
						{
							"ty": "tr",
							"p": {
								"a": 0,
								"k": [
									403.977,
									2643.698
								],
								"ix": 2
							},
							"a": {
								"a": 0,
								"k": [
									0,
									0
								],
								"ix": 1
							},
							"s": {
								"a": 0,
								"k": [
									100,
									100
								],
								"ix": 3
							},
							"r": {
								"a": 0,
								"k": 0,
								"ix": 6
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 7
							},
							"sk": {
								"a": 0,
								"k": 0,
								"ix": 4
							},
							"sa": {
								"a": 0,
								"k": 0,
								"ix": 5
							},
							"nm": "Transform"
						}
					],
					"nm": "Group 10",
					"np": 2,
					"cix": 2,
					"bm": 0,
					"ix": 10,
					"mn": "ADBE Vector Group",
					"hd": false
				},
				{
					"ty": "gr",
					"it": [
						{
							"ind": 0,
							"ty": "sh",
							"ix": 1,
							"ks": {
								"a": 0,
								"k": {
									"i": [
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										]
									],
									"o": [
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										]
									],
									"v": [
										[
											-12.698,
											-17.927
										],
										[
											-7.039,
											17.928
										],
										[
											12.698,
											7.092
										]
									],
									"c": true
								},
								"ix": 2
							},
							"nm": "Path 1",
							"mn": "ADBE Vector Shape - Group",
							"hd": false
						},
						{
							"ty": "fl",
							"c": {
								"a": 0,
								"k": [
									0.376470618154,
									0.525490196078,
									0.729411764706,
									1
								],
								"ix": 4
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 5
							},
							"r": 1,
							"bm": 0,
							"nm": "Fill 1",
							"mn": "ADBE Vector Graphic - Fill",
							"hd": false
						},
						{
							"ty": "tr",
							"p": {
								"a": 0,
								"k": [
									392.053,
									2614.064
								],
								"ix": 2
							},
							"a": {
								"a": 0,
								"k": [
									0,
									0
								],
								"ix": 1
							},
							"s": {
								"a": 0,
								"k": [
									100,
									100
								],
								"ix": 3
							},
							"r": {
								"a": 0,
								"k": 0,
								"ix": 6
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 7
							},
							"sk": {
								"a": 0,
								"k": 0,
								"ix": 4
							},
							"sa": {
								"a": 0,
								"k": 0,
								"ix": 5
							},
							"nm": "Transform"
						}
					],
					"nm": "Group 11",
					"np": 2,
					"cix": 2,
					"bm": 0,
					"ix": 11,
					"mn": "ADBE Vector Group",
					"hd": false
				},
				{
					"ty": "gr",
					"it": [
						{
							"ind": 0,
							"ty": "sh",
							"ix": 1,
							"ks": {
								"a": 0,
								"k": {
									"i": [
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										]
									],
									"o": [
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										]
									],
									"v": [
										[
											124.754,
											-61.72
										],
										[
											103.576,
											-133.777
										],
										[
											69.52,
											-120.619
										],
										[
											37.592,
											-122.263
										],
										[
											47.073,
											-146.937
										],
										[
											24.458,
											-164.14
										],
										[
											28.884,
											-181.764
										],
										[
											17.992,
											-181.764
										],
										[
											3.488,
											-206.783
										],
										[
											-59.737,
											-116.362
										],
										[
											-62.866,
											-115.396
										],
										[
											-74.444,
											-134.551
										],
										[
											-124.753,
											-33.931
										],
										[
											-103.855,
											16.379
										],
										[
											-53.546,
											84.491
										],
										[
											-48.128,
											131.704
										],
										[
											5.254,
											160.649
										],
										[
											21.145,
											206.782
										],
										[
											38.37,
											131.704
										],
										[
											71.068,
											118.546
										],
										[
											79.224,
											86.561
										],
										[
											80.896,
											56.905
										],
										[
											108.993,
											21.023
										]
									],
									"c": true
								},
								"ix": 2
							},
							"nm": "Path 1",
							"mn": "ADBE Vector Shape - Group",
							"hd": false
						},
						{
							"ty": "fl",
							"c": {
								"a": 0,
								"k": [
									1,
									1,
									1,
									1
								],
								"ix": 4
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 5
							},
							"r": 1,
							"bm": 0,
							"nm": "Fill 1",
							"mn": "ADBE Vector Graphic - Fill",
							"hd": false
						},
						{
							"ty": "tr",
							"p": {
								"a": 0,
								"k": [
									375.867,
									2802.92
								],
								"ix": 2
							},
							"a": {
								"a": 0,
								"k": [
									0,
									0
								],
								"ix": 1
							},
							"s": {
								"a": 0,
								"k": [
									100,
									100
								],
								"ix": 3
							},
							"r": {
								"a": 0,
								"k": 0,
								"ix": 6
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 7
							},
							"sk": {
								"a": 0,
								"k": 0,
								"ix": 4
							},
							"sa": {
								"a": 0,
								"k": 0,
								"ix": 5
							},
							"nm": "Transform"
						}
					],
					"nm": "Group 12",
					"np": 2,
					"cix": 2,
					"bm": 0,
					"ix": 12,
					"mn": "ADBE Vector Group",
					"hd": false
				}
			],
			"ip": 0,
			"op": 2771,
			"st": 0,
			"bm": 0
		},
		{
			"ddd": 0,
			"ind": 3,
			"ty": 4,
			"nm": "3B Iceberg Top/LiveMarket_Full_Page_forAe_01 Outlines 2",
			"sr": 1,
			"ks": {
				"o": {
					"a": 0,
					"k": 100,
					"ix": 11
				},
				"r": {
					"a": 1,
					"k": [
						{
							"i": {
								"x": [
									0.667
								],
								"y": [
									1
								]
							},
							"o": {
								"x": [
									0.333
								],
								"y": [
									0
								]
							},
							"t": 0,
							"s": [
								1.315
							]
						},
						{
							"i": {
								"x": [
									0.667
								],
								"y": [
									1
								]
							},
							"o": {
								"x": [
									0.333
								],
								"y": [
									0
								]
							},
							"t": 63,
							"s": [
								-1.685
							]
						},
						{
							"t": 120,
							"s": [
								1.315
							]
						}
					],
					"ix": 10
				},
				"p": {
					"a": 1,
					"k": [
						{
							"i": {
								"x": 0.667,
								"y": 1
							},
							"o": {
								"x": 0.333,
								"y": 0
							},
							"t": 0,
							"s": [
								142.019,
								212.646,
								0
							],
							"to": [
								0,
								0,
								0
							],
							"ti": [
								0,
								0,
								0
							]
						},
						{
							"i": {
								"x": 0.667,
								"y": 1
							},
							"o": {
								"x": 0.333,
								"y": 0
							},
							"t": 54,
							"s": [
								142.019,
								219.646,
								0
							],
							"to": [
								0,
								0,
								0
							],
							"ti": [
								0,
								0,
								0
							]
						},
						{
							"t": 120,
							"s": [
								142.019,
								212.646,
								0
							]
						}
					],
					"ix": 2
				},
				"a": {
					"a": 0,
					"k": [
						382,
						2800.5,
						0
					],
					"ix": 1
				},
				"s": {
					"a": 0,
					"k": [
						100,
						100,
						100
					],
					"ix": 6
				}
			},
			"ao": 0,
			"shapes": [
				{
					"ty": "gr",
					"it": [
						{
							"ind": 0,
							"ty": "sh",
							"ix": 1,
							"ks": {
								"a": 0,
								"k": {
									"i": [
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										]
									],
									"o": [
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										]
									],
									"v": [
										[
											-23.607,
											-44.583
										],
										[
											-26.316,
											13.817
										],
										[
											26.316,
											44.583
										]
									],
									"c": true
								},
								"ix": 2
							},
							"nm": "Path 1",
							"mn": "ADBE Vector Shape - Group",
							"hd": false
						},
						{
							"ty": "fl",
							"c": {
								"a": 0,
								"k": [
									0.466666696586,
									0.552941176471,
									0.635294117647,
									1
								],
								"ix": 4
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 5
							},
							"r": 1,
							"bm": 0,
							"nm": "Fill 1",
							"mn": "ADBE Vector Graphic - Fill",
							"hd": false
						},
						{
							"ty": "tr",
							"p": {
								"a": 0,
								"k": [
									420.618,
									2876.883
								],
								"ix": 2
							},
							"a": {
								"a": 0,
								"k": [
									0,
									0
								],
								"ix": 1
							},
							"s": {
								"a": 0,
								"k": [
									100,
									100
								],
								"ix": 3
							},
							"r": {
								"a": 0,
								"k": 0,
								"ix": 6
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 7
							},
							"sk": {
								"a": 0,
								"k": 0,
								"ix": 4
							},
							"sa": {
								"a": 0,
								"k": 0,
								"ix": 5
							},
							"nm": "Transform"
						}
					],
					"nm": "Group 1",
					"np": 2,
					"cix": 2,
					"bm": 0,
					"ix": 1,
					"mn": "ADBE Vector Group",
					"hd": false
				},
				{
					"ty": "gr",
					"it": [
						{
							"ind": 0,
							"ty": "sh",
							"ix": 1,
							"ks": {
								"a": 0,
								"k": {
									"i": [
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										]
									],
									"o": [
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										]
									],
									"v": [
										[
											-34.637,
											-37.539
										],
										[
											29.677,
											-22.059
										],
										[
											34.636,
											37.539
										]
									],
									"c": true
								},
								"ix": 2
							},
							"nm": "Path 1",
							"mn": "ADBE Vector Shape - Group",
							"hd": false
						},
						{
							"ty": "fl",
							"c": {
								"a": 0,
								"k": [
									0.203921583587,
									0.321568627451,
									0.486274539723,
									1
								],
								"ix": 4
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 5
							},
							"r": 1,
							"bm": 0,
							"nm": "Fill 1",
							"mn": "ADBE Vector Graphic - Fill",
							"hd": false
						},
						{
							"ty": "tr",
							"p": {
								"a": 0,
								"k": [
									362.375,
									2972.164
								],
								"ix": 2
							},
							"a": {
								"a": 0,
								"k": [
									0,
									0
								],
								"ix": 1
							},
							"s": {
								"a": 0,
								"k": [
									100,
									100
								],
								"ix": 3
							},
							"r": {
								"a": 0,
								"k": 0,
								"ix": 6
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 7
							},
							"sk": {
								"a": 0,
								"k": 0,
								"ix": 4
							},
							"sa": {
								"a": 0,
								"k": 0,
								"ix": 5
							},
							"nm": "Transform"
						}
					],
					"nm": "Group 2",
					"np": 2,
					"cix": 2,
					"bm": 0,
					"ix": 2,
					"mn": "ADBE Vector Group",
					"hd": false
				},
				{
					"ty": "gr",
					"it": [
						{
							"ind": 0,
							"ty": "sh",
							"ix": 1,
							"ks": {
								"a": 0,
								"k": {
									"i": [
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										]
									],
									"o": [
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										]
									],
									"v": [
										[
											-22.482,
											44.118
										],
										[
											-27.44,
											-15.48
										],
										[
											-7.781,
											-44.118
										],
										[
											27.44,
											-44.118
										]
									],
									"c": true
								},
								"ix": 2
							},
							"nm": "Path 1",
							"mn": "ADBE Vector Shape - Group",
							"hd": false
						},
						{
							"ty": "fl",
							"c": {
								"a": 0,
								"k": [
									0.345098039216,
									0.443137284821,
									0.572549019608,
									1
								],
								"ix": 4
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 5
							},
							"r": 1,
							"bm": 0,
							"nm": "Fill 1",
							"mn": "ADBE Vector Graphic - Fill",
							"hd": false
						},
						{
							"ty": "tr",
							"p": {
								"a": 0,
								"k": [
									419.494,
									2965.584
								],
								"ix": 2
							},
							"a": {
								"a": 0,
								"k": [
									0,
									0
								],
								"ix": 1
							},
							"s": {
								"a": 0,
								"k": [
									100,
									100
								],
								"ix": 3
							},
							"r": {
								"a": 0,
								"k": 0,
								"ix": 6
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 7
							},
							"sk": {
								"a": 0,
								"k": 0,
								"ix": 4
							},
							"sa": {
								"a": 0,
								"k": 0,
								"ix": 5
							},
							"nm": "Transform"
						}
					],
					"nm": "Group 3",
					"np": 2,
					"cix": 2,
					"bm": 0,
					"ix": 3,
					"mn": "ADBE Vector Group",
					"hd": false
				},
				{
					"ty": "gr",
					"it": [
						{
							"ind": 0,
							"ty": "sh",
							"ix": 1,
							"ks": {
								"a": 0,
								"k": {
									"i": [
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										]
									],
									"o": [
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										]
									],
									"v": [
										[
											5.999,
											48.761
										],
										[
											-43.924,
											-40.404
										],
										[
											43.924,
											-48.761
										],
										[
											43.924,
											17.996
										]
									],
									"c": true
								},
								"ix": 2
							},
							"nm": "Path 1",
							"mn": "ADBE Vector Shape - Group",
							"hd": false
						},
						{
							"ty": "fl",
							"c": {
								"a": 0,
								"k": [
									0.337254901961,
									0.435294147566,
									0.564705882353,
									1
								],
								"ix": 4
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 5
							},
							"r": 1,
							"bm": 0,
							"nm": "Fill 1",
							"mn": "ADBE Vector Graphic - Fill",
							"hd": false
						},
						{
							"ty": "tr",
							"p": {
								"a": 0,
								"k": [
									440.936,
									2872.705
								],
								"ix": 2
							},
							"a": {
								"a": 0,
								"k": [
									0,
									0
								],
								"ix": 1
							},
							"s": {
								"a": 0,
								"k": [
									100,
									100
								],
								"ix": 3
							},
							"r": {
								"a": 0,
								"k": 0,
								"ix": 6
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 7
							},
							"sk": {
								"a": 0,
								"k": 0,
								"ix": 4
							},
							"sa": {
								"a": 0,
								"k": 0,
								"ix": 5
							},
							"nm": "Transform"
						}
					],
					"nm": "Group 4",
					"np": 2,
					"cix": 2,
					"bm": 0,
					"ix": 4,
					"mn": "ADBE Vector Group",
					"hd": false
				},
				{
					"ty": "gr",
					"it": [
						{
							"ind": 0,
							"ty": "sh",
							"ix": 1,
							"ks": {
								"a": 0,
								"k": {
									"i": [
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										]
									],
									"o": [
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										]
									],
									"v": [
										[
											8.321,
											-5.63
										],
										[
											-69.079,
											33.591
										],
										[
											18.77,
											25.233
										],
										[
											69.079,
											-33.591
										]
									],
									"c": true
								},
								"ix": 2
							},
							"nm": "Path 1",
							"mn": "ADBE Vector Shape - Group",
							"hd": false
						},
						{
							"ty": "fl",
							"c": {
								"a": 0,
								"k": [
									0.203921583587,
									0.321568627451,
									0.486274539723,
									1
								],
								"ix": 4
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 5
							},
							"r": 1,
							"bm": 0,
							"nm": "Fill 1",
							"mn": "ADBE Vector Graphic - Fill",
							"hd": false
						},
						{
							"ty": "tr",
							"p": {
								"a": 0,
								"k": [
									466.091,
									2798.709
								],
								"ix": 2
							},
							"a": {
								"a": 0,
								"k": [
									0,
									0
								],
								"ix": 1
							},
							"s": {
								"a": 0,
								"k": [
									100,
									100
								],
								"ix": 3
							},
							"r": {
								"a": 0,
								"k": 0,
								"ix": 6
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 7
							},
							"sk": {
								"a": 0,
								"k": 0,
								"ix": 4
							},
							"sa": {
								"a": 0,
								"k": 0,
								"ix": 5
							},
							"nm": "Transform"
						}
					],
					"nm": "Group 5",
					"np": 2,
					"cix": 2,
					"bm": 0,
					"ix": 5,
					"mn": "ADBE Vector Group",
					"hd": false
				},
				{
					"ty": "gr",
					"it": [
						{
							"ind": 0,
							"ty": "sh",
							"ix": 1,
							"ks": {
								"a": 0,
								"k": {
									"i": [
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										]
									],
									"o": [
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										]
									],
									"v": [
										[
											5.612,
											-26.364
										],
										[
											-25.348,
											-61.968
										],
										[
											-30.379,
											-26.364
										],
										[
											-30.379,
											61.968
										],
										[
											30.38,
											34.008
										]
									],
									"c": true
								},
								"ix": 2
							},
							"nm": "Path 1",
							"mn": "ADBE Vector Shape - Group",
							"hd": false
						},
						{
							"ty": "fl",
							"c": {
								"a": 0,
								"k": [
									0.466666696586,
									0.552941176471,
									0.635294117647,
									1
								],
								"ix": 4
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 5
							},
							"r": 1,
							"bm": 0,
							"nm": "Fill 1",
							"mn": "ADBE Vector Graphic - Fill",
							"hd": false
						},
						{
							"ty": "tr",
							"p": {
								"a": 0,
								"k": [
									504.79,
									2731.112
								],
								"ix": 2
							},
							"a": {
								"a": 0,
								"k": [
									0,
									0
								],
								"ix": 1
							},
							"s": {
								"a": 0,
								"k": [
									100,
									100
								],
								"ix": 3
							},
							"r": {
								"a": 0,
								"k": 0,
								"ix": 6
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 7
							},
							"sk": {
								"a": 0,
								"k": 0,
								"ix": 4
							},
							"sa": {
								"a": 0,
								"k": 0,
								"ix": 5
							},
							"nm": "Transform"
						}
					],
					"nm": "Group 6",
					"np": 2,
					"cix": 2,
					"bm": 0,
					"ix": 6,
					"mn": "ADBE Vector Group",
					"hd": false
				},
				{
					"ty": "gr",
					"it": [
						{
							"ind": 0,
							"ty": "sh",
							"ix": 1,
							"ks": {
								"a": 0,
								"k": {
									"i": [
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										]
									],
									"o": [
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										]
									],
									"v": [
										[
											0.072,
											-26.378
										],
										[
											-28.516,
											26.379
										],
										[
											28.516,
											7.872
										]
									],
									"c": true
								},
								"ix": 2
							},
							"nm": "Path 1",
							"mn": "ADBE Vector Shape - Group",
							"hd": false
						},
						{
							"ty": "fl",
							"c": {
								"a": 0,
								"k": [
									0.466666696586,
									0.552941176471,
									0.635294117647,
									1
								],
								"ix": 4
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 5
							},
							"r": 1,
							"bm": 0,
							"nm": "Fill 1",
							"mn": "ADBE Vector Graphic - Fill",
							"hd": false
						},
						{
							"ty": "tr",
							"p": {
								"a": 0,
								"k": [
									384.943,
									2658.37
								],
								"ix": 2
							},
							"a": {
								"a": 0,
								"k": [
									0,
									0
								],
								"ix": 1
							},
							"s": {
								"a": 0,
								"k": [
									100,
									100
								],
								"ix": 3
							},
							"r": {
								"a": 0,
								"k": 0,
								"ix": 6
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 7
							},
							"sk": {
								"a": 0,
								"k": 0,
								"ix": 4
							},
							"sa": {
								"a": 0,
								"k": 0,
								"ix": 5
							},
							"nm": "Transform"
						}
					],
					"nm": "Group 7",
					"np": 2,
					"cix": 2,
					"bm": 0,
					"ix": 7,
					"mn": "ADBE Vector Group",
					"hd": false
				},
				{
					"ty": "gr",
					"it": [
						{
							"ind": 0,
							"ty": "sh",
							"ix": 1,
							"ks": {
								"a": 0,
								"k": {
									"i": [
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										]
									],
									"o": [
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										]
									],
									"v": [
										[
											-7.353,
											-12.287
										],
										[
											3.702,
											12.287
										],
										[
											7.353,
											5.902
										]
									],
									"c": true
								},
								"ix": 2
							},
							"nm": "Path 1",
							"mn": "ADBE Vector Shape - Group",
							"hd": false
						},
						{
							"ty": "fl",
							"c": {
								"a": 0,
								"k": [
									0.203921583587,
									0.321568627451,
									0.486274539723,
									1
								],
								"ix": 4
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 5
							},
							"r": 1,
							"bm": 0,
							"nm": "Fill 1",
							"mn": "ADBE Vector Graphic - Fill",
							"hd": false
						},
						{
							"ty": "tr",
							"p": {
								"a": 0,
								"k": [
									308.776,
									2680.657
								],
								"ix": 2
							},
							"a": {
								"a": 0,
								"k": [
									0,
									0
								],
								"ix": 1
							},
							"s": {
								"a": 0,
								"k": [
									100,
									100
								],
								"ix": 3
							},
							"r": {
								"a": 0,
								"k": 0,
								"ix": 6
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 7
							},
							"sk": {
								"a": 0,
								"k": 0,
								"ix": 4
							},
							"sa": {
								"a": 0,
								"k": 0,
								"ix": 5
							},
							"nm": "Transform"
						}
					],
					"nm": "Group 8",
					"np": 2,
					"cix": 2,
					"bm": 0,
					"ix": 8,
					"mn": "ADBE Vector Group",
					"hd": false
				},
				{
					"ty": "gr",
					"it": [
						{
							"ind": 0,
							"ty": "sh",
							"ix": 1,
							"ks": {
								"a": 0,
								"k": {
									"i": [
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										]
									],
									"o": [
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										]
									],
									"v": [
										[
											26.122,
											7.838
										],
										[
											-26.123,
											18.481
										],
										[
											-5.805,
											-8.222
										],
										[
											3.676,
											-18.481
										]
									],
									"c": true
								},
								"ix": 2
							},
							"nm": "Path 1",
							"mn": "ADBE Vector Shape - Group",
							"hd": false
						},
						{
							"ty": "fl",
							"c": {
								"a": 0,
								"k": [
									0.407843167174,
									0.494117676978,
									0.596078431373,
									1
								],
								"ix": 4
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 5
							},
							"r": 1,
							"bm": 0,
							"nm": "Fill 1",
							"mn": "ADBE Vector Graphic - Fill",
							"hd": false
						},
						{
							"ty": "tr",
							"p": {
								"a": 0,
								"k": [
									419.264,
									2674.464
								],
								"ix": 2
							},
							"a": {
								"a": 0,
								"k": [
									0,
									0
								],
								"ix": 1
							},
							"s": {
								"a": 0,
								"k": [
									100,
									100
								],
								"ix": 3
							},
							"r": {
								"a": 0,
								"k": 0,
								"ix": 6
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 7
							},
							"sk": {
								"a": 0,
								"k": 0,
								"ix": 4
							},
							"sa": {
								"a": 0,
								"k": 0,
								"ix": 5
							},
							"nm": "Transform"
						}
					],
					"nm": "Group 9",
					"np": 2,
					"cix": 2,
					"bm": 0,
					"ix": 9,
					"mn": "ADBE Vector Group",
					"hd": false
				},
				{
					"ty": "gr",
					"it": [
						{
							"ind": 0,
							"ty": "sh",
							"ix": 1,
							"ks": {
								"a": 0,
								"k": {
									"i": [
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										]
									],
									"o": [
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										]
									],
									"v": [
										[
											18.963,
											12.284
										],
										[
											9.482,
											22.542
										],
										[
											-18.963,
											-11.707
										],
										[
											0.774,
											-22.542
										]
									],
									"c": true
								},
								"ix": 2
							},
							"nm": "Path 1",
							"mn": "ADBE Vector Shape - Group",
							"hd": false
						},
						{
							"ty": "fl",
							"c": {
								"a": 0,
								"k": [
									0.337254901961,
									0.427451010311,
									0.537254901961,
									1
								],
								"ix": 4
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 5
							},
							"r": 1,
							"bm": 0,
							"nm": "Fill 1",
							"mn": "ADBE Vector Graphic - Fill",
							"hd": false
						},
						{
							"ty": "tr",
							"p": {
								"a": 0,
								"k": [
									403.977,
									2643.698
								],
								"ix": 2
							},
							"a": {
								"a": 0,
								"k": [
									0,
									0
								],
								"ix": 1
							},
							"s": {
								"a": 0,
								"k": [
									100,
									100
								],
								"ix": 3
							},
							"r": {
								"a": 0,
								"k": 0,
								"ix": 6
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 7
							},
							"sk": {
								"a": 0,
								"k": 0,
								"ix": 4
							},
							"sa": {
								"a": 0,
								"k": 0,
								"ix": 5
							},
							"nm": "Transform"
						}
					],
					"nm": "Group 10",
					"np": 2,
					"cix": 2,
					"bm": 0,
					"ix": 10,
					"mn": "ADBE Vector Group",
					"hd": false
				},
				{
					"ty": "gr",
					"it": [
						{
							"ind": 0,
							"ty": "sh",
							"ix": 1,
							"ks": {
								"a": 0,
								"k": {
									"i": [
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										]
									],
									"o": [
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										]
									],
									"v": [
										[
											-12.698,
											-17.927
										],
										[
											-7.039,
											17.928
										],
										[
											12.698,
											7.092
										]
									],
									"c": true
								},
								"ix": 2
							},
							"nm": "Path 1",
							"mn": "ADBE Vector Shape - Group",
							"hd": false
						},
						{
							"ty": "fl",
							"c": {
								"a": 0,
								"k": [
									0.203921583587,
									0.321568627451,
									0.486274539723,
									1
								],
								"ix": 4
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 5
							},
							"r": 1,
							"bm": 0,
							"nm": "Fill 1",
							"mn": "ADBE Vector Graphic - Fill",
							"hd": false
						},
						{
							"ty": "tr",
							"p": {
								"a": 0,
								"k": [
									392.053,
									2614.064
								],
								"ix": 2
							},
							"a": {
								"a": 0,
								"k": [
									0,
									0
								],
								"ix": 1
							},
							"s": {
								"a": 0,
								"k": [
									100,
									100
								],
								"ix": 3
							},
							"r": {
								"a": 0,
								"k": 0,
								"ix": 6
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 7
							},
							"sk": {
								"a": 0,
								"k": 0,
								"ix": 4
							},
							"sa": {
								"a": 0,
								"k": 0,
								"ix": 5
							},
							"nm": "Transform"
						}
					],
					"nm": "Group 11",
					"np": 2,
					"cix": 2,
					"bm": 0,
					"ix": 11,
					"mn": "ADBE Vector Group",
					"hd": false
				},
				{
					"ty": "gr",
					"it": [
						{
							"ind": 0,
							"ty": "sh",
							"ix": 1,
							"ks": {
								"a": 0,
								"k": {
									"i": [
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										]
									],
									"o": [
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										]
									],
									"v": [
										[
											142.029,
											-37.801
										],
										[
											86.3,
											-133.776
										],
										[
											52.245,
											-120.618
										],
										[
											15.591,
											-119.958
										],
										[
											29.798,
											-146.937
										],
										[
											10.836,
											-157.682
										],
										[
											11.609,
											-181.763
										],
										[
											-1.089,
											-184.171
										],
										[
											-13.786,
											-206.782
										],
										[
											-77.013,
											-116.361
										],
										[
											-81.326,
											-117.447
										],
										[
											-83.094,
											-120.354
										],
										[
											-91.719,
											-134.551
										],
										[
											-142.029,
											-33.93
										],
										[
											-121.13,
											16.38
										],
										[
											-70.82,
											84.492
										],
										[
											-65.402,
											131.705
										],
										[
											-15.789,
											159.861
										],
										[
											3.87,
											206.782
										],
										[
											22.38,
											135.522
										],
										[
											53.792,
											118.547
										],
										[
											54.978,
											93.573
										],
										[
											65.592,
											69.786
										],
										[
											91.718,
											21.024
										],
										[
											93.137,
											-2.2
										]
									],
									"c": true
								},
								"ix": 2
							},
							"nm": "Path 1",
							"mn": "ADBE Vector Shape - Group",
							"hd": false
						},
						{
							"ty": "fl",
							"c": {
								"a": 0,
								"k": [
									0.545098039216,
									0.619607843137,
									0.686274509804,
									1
								],
								"ix": 4
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 5
							},
							"r": 1,
							"bm": 0,
							"nm": "Fill 1",
							"mn": "ADBE Vector Graphic - Fill",
							"hd": false
						},
						{
							"ty": "tr",
							"p": {
								"a": 0,
								"k": [
									393.142,
									2802.92
								],
								"ix": 2
							},
							"a": {
								"a": 0,
								"k": [
									0,
									0
								],
								"ix": 1
							},
							"s": {
								"a": 0,
								"k": [
									100,
									100
								],
								"ix": 3
							},
							"r": {
								"a": 0,
								"k": 0,
								"ix": 6
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 7
							},
							"sk": {
								"a": 0,
								"k": 0,
								"ix": 4
							},
							"sa": {
								"a": 0,
								"k": 0,
								"ix": 5
							},
							"nm": "Transform"
						}
					],
					"nm": "Group 12",
					"np": 2,
					"cix": 2,
					"bm": 0,
					"ix": 12,
					"mn": "ADBE Vector Group",
					"hd": false
				}
			],
			"ip": 0,
			"op": 2771,
			"st": 0,
			"bm": 0
		}
	],
	"markers": []
};


//////////////////
// WEBPACK FOOTER
// ./frontend/pages/LiveMarkets/animations/iceberg/Iceberg_Loop_04_Lottie.json
// module id = 652
// module chunks = 0